"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExcludeKeyword = exports.isByDate = exports.isRedirectOnConfirm = exports.isForm = exports.isRoom = exports.isOr = exports.isMulti = exports.isProxy = exports.detectPagePaidFunctions = void 0;
const lodash_1 = require("lodash");
/**
 * ページで使用されている有料の機能を検知する。
 * @param plan
 * @param publicPageParams
 */
const detectPagePaidFunctions = (ownerUid, publicPageParams, publicBookingViewSetting, publicProfile) => {
    const formulaDecoded = JSON.parse(publicPageParams.formula);
    return (0, lodash_1.compact)([
        (0, exports.isProxy)(ownerUid, formulaDecoded) ? 'proxy' : null,
        (0, exports.isMulti)(formulaDecoded) ? 'multi' : null,
        (0, exports.isOr)(formulaDecoded) ? 'or' : null,
        (0, exports.isRoom)(publicPageParams.room) ? 'room' : null,
        (0, exports.isForm)(publicPageParams.customFormRef) ? 'customForm' : null,
        (0, exports.isRedirectOnConfirm)(publicPageParams.redirectOnConfirm)
            ? 'redirectOnConfirm'
            : null,
        (0, exports.isExcludeKeyword)(publicBookingViewSetting.excludeKeywords)
            ? 'keyword'
            : null,
        (0, exports.isByDate)(publicPageParams.dateTimeRange) ? 'byDate' : null,
        publicProfile.hasMultiAccounts ? 'multiAccount' : null,
        publicPageParams.startMessage || publicPageParams.endMessage
            ? 'startAndEndMessage'
            : null
    ]);
};
exports.detectPagePaidFunctions = detectPagePaidFunctions;
// 調整方法
// 代理
const isProxy = (ownerUid, formulaDecoded) => {
    const flattenFormula = (0, lodash_1.flatten)(formulaDecoded);
    return !flattenFormula.includes(ownerUid);
};
exports.isProxy = isProxy;
// 複数人
const isMulti = (formulaDecoded) => {
    return formulaDecoded.some((f) => f.length > 1);
};
exports.isMulti = isMulti;
// または
const isOr = (formulaDecoded) => {
    return formulaDecoded.length > 1;
};
exports.isOr = isOr;
// 会議室
const isRoom = (room) => {
    return !(0, lodash_1.isNull)(room) && (room === null || room === void 0 ? void 0 : room.length) > 0;
};
exports.isRoom = isRoom;
// フォーム
const isForm = (form) => {
    return form !== null;
};
exports.isForm = isForm;
// リダイレクト
const isRedirectOnConfirm = (redirectOnConfirm) => {
    return redirectOnConfirm !== null;
};
exports.isRedirectOnConfirm = isRedirectOnConfirm;
// 日付の指定
const isByDate = (dateTimeRange) => {
    return dateTimeRange.type === 'date';
};
exports.isByDate = isByDate;
// キーワード
const isExcludeKeyword = (keywords) => {
    return keywords.length > 0;
};
exports.isExcludeKeyword = isExcludeKeyword;
//# sourceMappingURL=detectPagePaidFunctions.js.map